import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import { numberFormat } from 'helper';
import ReasonModal from '../component/ReasonModal';
import * as actions from '../../../action';
import * as c from '../../../constant';
import ViewTaxableReasonModal from '../component/ViewTaxableReasonModal';

function LandPropertyAssessmentContainer({
  getLandPropertyAssessmentList,
  getHistoryPropertyAssessmentList,
  landPropertyAssessmentList,
  updateLandPropertyAssessment,
  applicationId,
  applicationStatus,
  historyApplicationId,
  isLoading,
  type,
}) {
  const setModal = useContext(ModalContext);

  const handleChange = (e, id, data) => {
    const val =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    if (val === true) {
      const args = {
        ...data.attributes,
        taxability: 1,
        reason: '',
      };
      updateLandPropertyAssessment(id, data.id, args, () => {
        return type !== 'history'
          ? getLandPropertyAssessmentList(id)
          : getHistoryPropertyAssessmentList(historyApplicationId);
      });
    } else {
      setModal({
        isOpen: true,
        content: (
          <ReasonModal
            id={data.id}
            applicationId={id}
            updateList={data.attributes}
          />
        ),
        title: 'Add Exemption Reason',
        modalSize: 'modal-md',
      });
    }
  };

  const handleView = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Exemption Reason',
      isOpen: true,
      content: <ViewTaxableReasonModal taxableReason={dataInfo} />,
      modalSize: 'modal-lg',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryPropertyAssessmentList(historyApplicationId);
    else getLandPropertyAssessmentList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    if (type === 'history')
      getHistoryPropertyAssessmentList(historyApplicationId);
    else getLandPropertyAssessmentList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <div style={{ overflowX: 'auto' }}>
                <table
                  className="table table-borderless table-sm table-light"
                  style={{ width: '1000px', overflowX: 'auto' }}
                >
                  <thead className="table-header">
                    <tr>
                      <td className="font-weight-bold">Actual Use</td>
                      <td className="font-weight-bold pr-5">Area</td>
                      <td className="font-weight-bold">Market Value</td>
                      <td className="font-weight-bold">Assessment Level</td>
                      <td className="font-weight-bold">Assessed Value</td>
                      <td className="font-weight-bold">Taxability</td>
                      <td className="font-weight-bold">Tax Exempt Code</td>
                      <td className="font-weight-bold">Exemption Reason</td>
                    </tr>
                  </thead>
                  <tbody>
                    {landPropertyAssessmentList &&
                      landPropertyAssessmentList.length <= 0 && (
                        <tr className="text-center">
                          <td className="history-color" colSpan="7">
                            No data
                          </td>
                        </tr>
                      )}
                    {landPropertyAssessmentList &&
                      landPropertyAssessmentList.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {_.get(item, 'attributes.actual_use')}
                            </span>
                          </td>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {numberFormat(_.get(item, 'attributes.area'), 0)}
                            </span>
                          </td>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {numberFormat(
                                _.get(item, 'attributes.market_value'),
                                2
                              )}
                            </span>
                          </td>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {_.get(item, 'attributes.assessment_level')}
                            </span>
                          </td>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {numberFormat(
                                _.get(item, 'attributes.assessed_value'),
                                2
                              )}
                            </span>
                          </td>
                          <td className="text-center">
                            <input
                              name="taxability"
                              type="checkbox"
                              checked={_.get(item, 'attributes.taxability')}
                              disabled={
                                type === 'history' ||
                                applicationStatus === 'CANCELLED'
                              }
                              onChange={(e) =>
                                handleChange(e, applicationId, item)
                              }
                            />
                          </td>
                          <td>
                            <span style={{ color: '#65676b' }}>
                              {_.get(item, 'attributes.tax_exempt_code')}
                            </span>
                          </td>
                          {_.get(item, 'attributes.taxability') === 0 && (
                            <td className="text-center">
                              <button
                                type="button"
                                onClick={handleView(
                                  _.get(item, 'attributes.reason')
                                )}
                                className="btn-blank button-eye"
                              >
                                <i className="far fa-eye icon-view" />
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    <tr key="total">
                      <td>
                        <span style={{ color: '#65676b' }}>
                          <b>Total:</b>
                        </span>
                      </td>
                      <td>
                        <span style={{ color: '#65676b' }}>
                          <b>
                            {numberFormat(
                              _.reduce(
                                landPropertyAssessmentList,
                                (total, item) =>
                                  _.get(item, 'attributes.area') + total,
                                0
                              ),
                              0
                            )}
                          </b>
                        </span>
                      </td>
                      <td>
                        <span style={{ color: '#65676b' }}>
                          <b>
                            {numberFormat(
                              _.reduce(
                                landPropertyAssessmentList,
                                (total, item) =>
                                  _.get(item, 'attributes.market_value') +
                                  total,
                                0
                              ),
                              2
                            )}
                          </b>
                        </span>
                      </td>
                      <td />
                      <td>
                        <span style={{ color: '#65676b' }}>
                          <b>
                            {numberFormat(
                              _.reduce(
                                landPropertyAssessmentList,
                                (total, item) =>
                                  _.get(item, 'attributes.assessed_value') +
                                  total,
                                0
                              ),
                              2
                            )}
                          </b>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

LandPropertyAssessmentContainer.defaultProps = {
  applicationId: '',
  applicationStatus: '',
  historyApplicationId: '',
  type: '',
};

LandPropertyAssessmentContainer.propTypes = {
  getLandPropertyAssessmentList: PropTypes.instanceOf(Function).isRequired,
  getHistoryPropertyAssessmentList: PropTypes.instanceOf(Function).isRequired,
  landPropertyAssessmentList: PropTypes.instanceOf(Array).isRequired,
  updateLandPropertyAssessment: PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  applicationStatus: PropTypes.string,
  historyApplicationId: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landPropertyAssessmentList:
    _.get(api, `${c.GET_LAND_PROPERTY_ASSESSMENT}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_LAND_PROPERTY_ASSESSMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandPropertyAssessmentContainer);
